import { createContext } from 'react'

import { Action, INITIAL_STATE, PremiumInsightsState } from './reducer'

interface ContextState extends PremiumInsightsState {
  dispatch: React.Dispatch<Action>
}

const defaultValue = {
  ...INITIAL_STATE,
  dispatch: () => null,
}

const PremiumInsightsContext = createContext<ContextState>(defaultValue)

export default PremiumInsightsContext
